import { render } from "./3HubunganIndustri.vue?vue&type=template&id=7c55247a"
import script from "./3HubunganIndustri.vue?vue&type=script&lang=js"
export * from "./3HubunganIndustri.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__